module.exports = __webpack_public_path__ + "img/stationery-1.3775aa97.jpg";